import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './frontend/hooks/useAuth';
import App from './frontend/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
